import { getParams } from "../utlis/helpers";
import { ENV } from "../configs/environment";

const MMT_SESSION_KEY = "mmtSession";

const getAccessToken = () => {
  const { accessToken } = getParams();
  if (accessToken) return accessToken;
  try {
    return (
      JSON.parse(sessionStorage.getItem(MMT_SESSION_KEY) || "null")
        ?.accessToken || ""
    );
  } catch {
    return "";
  }
};

export const buildHeaders = () => {
  const { locale } = getParams();
  return {
    "Accept-Language": locale || "en",
    Accept: "application/json",
    Authorization: "Bearer " + getAccessToken(),
    "Access-Control-Allow-Origin": "*",
  };
};

// Backwards-compatible `config` object — `headers` is a getter so each axios
// call reads the latest locale/token at request time instead of at module load.
export const config = {
  get headers() {
    return buildHeaders();
  },
};

export const APP_URL = ENV.API_URL;
